import {Region} from "src/context/models/Session";

export const HEALTH_DASHBOARD_PATH = '/sp-api-status';
export const SPECTRUM_HUB_DOMAIN = 'spectrum-hub'

export const CONNECTION_ERROR = 'Failed to connect';

export const HEALTH_STATUS = {
    GREEN: "🟢",
    GREEN_WITH_INFO: "ℹ️",
    YELLOW: "🟡",
    RED: "🔴"
};

export const EVENT_SEVERITY = {
    RED: "RED",
    YELLOW: "YELLOW",
    GREEN: "GREEN",
    GREEN_WITH_INFO: "GREEN_WITH_INFO"
};

export const EVENT_TITLE = {
    RED: "Service Outage",
    YELLOW: "Service Affected",
    GREEN_WITH_INFO: "Informational"
};

export const EVENT_CARD_VARIANT = {
    RED: "danger",
    YELLOW: "warning",
    GREEN_WITH_INFO: "default"
};

export const REGION_LABEL = {
    [Region.NA]: "North America",
    [Region.EU]: "Europe",
    [Region.FE]: "Asia Pacific",
};

export const HEALTH_EVENT = "HEALTH_EVENT";
export const UTC = "UTC";
